module.exports = __webpack_public_path__ + "static/media/misiones-nav.f00553a9.png";